import { render, staticRenderFns } from "./WizardTabPane.vue?vue&type=template&id=48013e69&"
import script from "./WizardTabPane.vue?vue&type=script&lang=js&"
export * from "./WizardTabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports